import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"star"}/>
}
